module.exports = __webpack_public_path__ + "static/media/tree-step-3_2.af6939ae.svg";